import { svg } from "../svg";

export const BitwardenIcon = svg`
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="gxpms-icon-grad" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#2563EB"/>
      <stop offset="100%" stop-color="#06B6D4"/>
    </linearGradient>
  </defs>
  <rect width="20" height="20" rx="4" fill="url(#gxpms-icon-grad)"/>
  <path d="M 10 4 L 14.5 6.5 L 14.5 13.5 L 10 16 L 5.5 13.5 L 5.5 6.5 Z" fill="none" stroke="#FFFFFF" stroke-width="1" opacity="0.4"/>
  <path d="M 10 6.5 L 12.2 8.7 L 10 10.9 L 7.8 8.7 Z" fill="#FFFFFF"/>
  <path d="M 9.2 10 L 10.8 10 L 11.1 13.5 L 8.9 13.5 Z" fill="#FFFFFF"/>
</svg>
`;
